import React from 'react';
import { useRouter } from 'next/router';
import { Popup } from 'clad-ui';
import { styled } from '@linaria/react';
import { dataLayerPush } from '@chotot/web-gtm';
import { useSendOTP } from '~/apis/auth';
type Props = {
  open?: boolean;
  onClose?: () => void;
  data: {
    modal_header: string;
    modal_body: string;
    modal_button_text: string;
  } | null;
  phone: string;
};
const VerifyOTPPopup = (props: Props) => {
  const {
    open,
    onClose,
    data,
    phone
  } = props;
  const {
    query,
    push
  } = useRouter();
  const {
    fetch: sendOTP
  } = useSendOTP();
  const goVerifyOTP = () => {
    dataLayerPush({
      event: 'track_event',
      event_category: 'login',
      event_action: 'click',
      event_label: 'login_w_otp'
    });
    sendOTP(phone, 'mfa');
    push(`/login/otp?phone=${phone}&continue=${query.continue ? encodeURIComponent(query.continue as string) : ''}`);
  };
  return <Popup btnGroupDirection="column" primaryBtnLabel={data?.modal_button_text || 'Xác thực'} secondaryBtnLabel="Trở về" open={open} onClose={onClose} onPrimaryButtonClick={goVerifyOTP} onSecondaryButtonClick={onClose} title={data?.modal_header || 'Phát hiện đăng nhập tài khoản trên thiết bị mới'}>
      <Wrapper dangerouslySetInnerHTML={{
      __html: data?.modal_body || '<p>Vì lý do bảo mật, vui lòng xác thực OTP để đăng nhập vào tài khoản.</p>'
    }}></Wrapper>
    </Popup>;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wnkq9uq",
  propsAsIs: false
});
export default VerifyOTPPopup;

require("./VerifyOTPPopup.linaria.module.css!=!../../../node_modules/.pnpm/@linaria+webpack5-loader@4.1.17_webpack@5.95.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./VerifyOTPPopup.tsx");